import { STORE_NOTIFICATIONS_NAME } from '@/store_constants/notifications';

export function notify(dispatch, type, message) {
	dispatch(`${STORE_NOTIFICATIONS_NAME}/${type}`, { message }, { root: true });
}